<template>
  <header>
    <div class="usa-banner">
      <div class="usa-banner__header minh-0">
        <div class="usa-banner__inner">
          <img class="usa-banner__header-flag" width="16" height="11" src="/assets/img/us_flag_small.png"
            alt="U.S. Flag" />
          <p class="usa-banner__header-text">
            Official U.S. Department of State Visa Appointment Service
          </p>
        </div>
      </div>
    </div>
    <!-- pooja, 16-dec-25, 508: common for all, focus header section button on sequence left to right top to bottom indexing removed-->
    <div class="quick-notice" v-if="quickNotice" :class="permanentHide">
      <button id="notice-btn" class="notice-btn" v-on:click="showQuickNotice()">
        {{ translationKeywords['read-imp-notice'] || 'Read important notice' }}</button>
    </div>
    <div
      class="usa-overlay"
      v-on:click="showMobileMenu = !showMobileMenu"
      v-bind:class="{ 'is-visible': showMobileMenu }"></div>
    <!-- Shubham, 8-feb-2024, Resolve the parsing error were this.route was going null. To manage that made a function to check the route's availability -->
    <div v-if = "showHeader" class="usa-header usa-header--extended">

      <div class="usa-navbar">
        <div v-show="this.$route.name !== ''" class="usa-logo" id="extended-logo">
          <div class="department-logo">
             <div>
               <a href="" class="usa-grouped-logo" aria-label="U.S. Travel Docs">
                 <img src="/assets/images/US-Flag.svg" class="flag-img" alt="U.S Flag" />
                 <img src="/assets/images/DOS-Logo.svg" class="dos-img" alt="Deparment Of State Logo" />
                 <img src="/assets/images/USTravelDocs_White.svg" class="ustd-text" alt="USTravelDocs" />
               </a>
             </div>
             <div>
               <span v-if="country !== '' && !isDecommission"><a class="cgi-badge radius-pill tablet:font-sans-md country-tag" href="" :aria-label="country">{{ country.toLocaleUpperCase('en') }}</a></span>
             </div>
          </div>
        </div>
        <!-- pooja, 12-mar-26, removed homeonlyclass not in use and getting console errors -->
        <button v-if="country !== ''" type="button" class="usa-menu-btn" v-on:click="showMobileMenu = !showMobileMenu">
          <svg width="32" height="32" viewBox="0 0 32 32" role="img" focusable="false"
            aria-labelledby="svgMenuTitle" aria-describedby="svgMenuDescription">
            <title id="svgMenuTitle">Menu</title>
            <desc id="svgMenuDescription">Menu</desc>
            <path
              d="M4 10h24a2 2 0 0 0 0-4H4a2 2 0 0 0 0 4zm24 4H4a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4zm0 8H4a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4z" />
          </svg>
          {{ translationKeywords['menu'] || 'Menu' }}
        </button>
      </div>
      <!-- <nav
        class="usa-nav"
        aria-label="Primary header with 7 items"
        v-bind:class="{ 'is-visible': showMobileMenu }"
      > -->
      <nav class="usa-nav" v-bind:class="{ 'is-visible': showMobileMenu }">
        <div class="usa-nav__inner">
          <button type="button" class="usa-nav__close" v-on:click="showMobileMenu = !showMobileMenu">
            <img src="/assets/img/close.svg" alt="close" />
          </button>
          <div v-if="country !== ''" class="grid-row usa-nav__secondary" :class="singleHead">
            <div class="grid-col-12 desktop:grid-col-9">
              <!-- pooja, 16-jul-2025, 508-reads as nav items removed roles -->
              <ul class="usa-nav__primary usa-accordion" style="justify-content: center;">
                <li class="usa-nav__primary-item">
                  <a href="contact-us">{{ translationKeywords['contact'] || 'Contact' }}</a>
                </li>
                <li class="usa-nav__primary-item">
                  <a href="general-information#faqs">{{ translationKeywords['faqs'] || 'Faqs' }}</a>
                </li>
                <li class="usa-nav__primary-item">
                  <button type="button" class="usa-accordion__button usa-nav__link usa_nav__lang-dropdown"
                    :aria-expanded="toggleMenu ? 'true' : 'false'" aria-controls="change-language"
                    @click="toggleMenu = !toggleMenu" @keydown.esc="toggleMenu = !toggleMenu" v-click-outside="outside">
                    <span>{{ translationKeywords['change-language'] || 'Change language' }}</span>

                    <span class="mobile-only">
                      <span class="icon" v-if="toggleMenu">
                        <img src="/assets/img/minus-alt.svg" alt="collaps" width="12" height="15" />
                      </span>
                      <span class="icon" v-else-if="!toggleMenu">
                        <img src="/assets/img/plus-alt.svg" alt="expand" width="12" height="15" />
                      </span>
                    </span>
                  </button>
                  <ul class="usa-nav__submenu desktop:border desktop:border-base-lighter desktop:shadow-5 none"
                    id="change-language" :class="{ block: toggleMenu }" v-if="languages">
                    <li :key="i" v-for="(lang, i) of languages" class="usa-nav__submenu-item">
                      <a :href="langUrl(countryCode, lang)">{{ languageLabels[lang] }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <!-- pooja, 12-mar-26, added a https for safe search getting log error -->
            <div v-show="$route.name !== 'landing-page'" class="grid-col-12 desktop:grid-col-3">
              <form class="usa-search usa-search--small" action="https://www.bing.com/search">
                <input type="hidden" name="cp" value="utf-8" />
                <input type="hidden" name="q1" value="site:www.ustraveldocs.com/in" />
                <div role="search">
                  <label class="usa-sr-only" for="site-search">{{ translationKeywords['search-site'] || 'Search site'}}</label>
                  <!-- Shubham,5-feb-2024,Added unique name for search -->
                  <input class="usa-input" id="site-search" type="search" name="global search" />
                  <button type="submit" class="usa-button">
                    <span class="usa-sr-only">Search site</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <!-- <ul class="usa-nav__primary usa-accordion" :class="showSubMenu">
            <li :key="key" v-for="(menu, key) of data.fields.menuItemReferences">
              <document-renderer :documentId="menu.sys.id"></document-renderer>
            </li>
          </ul> -->
          <!--pooja,22-jan-26, header translation for menu  -->
          <!-- pooja, 12-mar-26, removed homeonlyclass not in use and getting console errors -->
          <ul class="usa-nav__primary usa-accordion" :class="showSubMenu" v-click-outside="outsideHamMenu">
            <button type="button" class="hamnav-btn" @keydown.esc="showHambMenu = !showHambMenu" v-on:click="showHambMenu = !showHambMenu">
              <svg width="32" height="32" viewBox="0 0 32 32" role="img" focusable="false"
                aria-labelledby="svgNavMenuTitle" aria-describedby="svgNavMenuDescription">
                <title id="svgMenuTitle">{{ translationKeywords['navigation'] || 'Navigation' }}</title>
                <desc id="svgMenuDescription">{{ translationKeywords['navigation'] || 'Navigation Menu' }}</desc>
                <path d="M4 10h24a2 2 0 0 0 0-4H4a2 2 0 0 0 0 4zm24 4H4a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4zm0 8H4a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4z" />
              </svg>
              <span>{{ translationKeywords['navigation'] || 'Navigation' }}</span>
            </button>
            <ul class="usa-nav__primary usa-accordion super-menu hidden-menu" :class="{ 'visible-menu': showHambMenu }">
              <li :key="key" v-for="(menu, key) of data.fields.menuItemReferences">
                <document-renderer :documentId="menu.sys.id"></document-renderer>
              </li>
            </ul>
          </ul>
          <!-- pooja, 17-jul-2025, 508- focus and reader tab in order as visible -->
          <div class="order-btns cgi-schedule-btns">
            <a :class="showSubMenu" :href="scheduleurl" id="acs-login"
              class="cgi-schedule cgi-schedule2 usa-button usa-button--green radius-0">
              <span class="cgi-schedule__text">
                {{ translationKeywords['visa-login'] || 'Visa Login' }}</span>
            </a>
            <a v-if="scheduleurl1 != ''" :class="showSubMenu" :href="scheduleurl1" id="visa-login"
              class="cgi-schedule usa-button usa-button--green radius-0">
              <span class="cgi-schedule__text">
                {{ translationKeywords['acs-login'] || 'Acs Login' }}</span>
            </a>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import { urlSlug, urlLangCode, urlCountryCode } from "@/helpers/url";
import {
  getLanguageUrlLabels,
  getLanguages,
  isRedirectToHomeOnLangChange,
  getTranslationKeywords,
  getDataByForTranslation,
  getCountryName,
  getLanguageLabels,
  //pooja, 10-july-2023, login url for country
  getCountryLoginUrl,
  getCountryAcsLoginUrl,
  getCountryResourceGroup
} from "@/store/api";

function outsideMenuClickHandler(event) {
  const isButtonClicked = event.target.closest(".quick-notice");
  const isMegaMenuClicked = event.target.closest("#group-fees-dialog");
}
export default {
  name: "header-component",
  props: ["data"],
  data: () => ({
    showHambMenu: false,
    toggleMenu: false,
    languages: null,
    languageLabels: '',
    languageUrlLabels: '',
    countryCode: null,
    showMobileMenu: false,
    languageChangeRedirect: false,
    translationKeywords: {},
    pageData: {},
    country: '',
    scheduleurl: '',
    scheduleurl1: '',
    fullLanguage: '',
    acsflag: false,
    isDecommission: false,
    quickNotice: false,
    permanentHide: '',
  }),
  computed: {
    showSubMenu() {
      var urlSlugText = urlSlug();
      if (urlSlugText == "") return "none";
      else return "";
    },
    singleHead() {
      var urlSlugText = urlSlug();
      if (urlSlugText == "") return "single-head";
      else return "";
    },
    // Shubham, 8-feb-2024, Added function to check the route's availability
    isRouteNameAvailable() {

      if (this.$route && this.$route.name) return true;
      else return false;
    },
    // pooja, 25-jan-26, console error in includes  method
    showHeader() {
      const name = this.$route.name || '';
      return (
        this.isRouteNameAvailable &&
        !name.includes('depositslip') &&
        !name.includes('landing')
      );
    }
  },
  methods: {
    outsideMenuClickHandler: outsideMenuClickHandler,
    showQuickNotice() {
      this.quickNotice = false;
      // this.showModal = true;
      this.$root.$emit("modal-popup:show");
      this.$nextTick(() => {
        this.$el.querySelector('.usa-dialog__close').focus();
      });
    },
    langUrl(countryCode, lang) {

      const url = new URL(location.href);
      const pathParts = url.pathname.split("/").filter((v) => v);
      if (this.languageChangeRedirect && (lang == 'ps' || lang == 'pr' || lang == 'hi')) {
        url.pathname = `/${pathParts[0]}/${lang}`;
        url.hash = '';
      } else {
        pathParts[1] = lang;
        url.pathname = pathParts.join("/");
      }
      return url.toString();
    },
    outside: function (e) {
      this.toggleMenu = false;
    },
    outsideHamMenu: function (e) {
      this.showHambMenu = false;
    },
    // pooja,2-jan-26, async await implementation
    async loadLanguageData() {
      const [
        languages,
        languageUrlLabels,
        languageLabels,
        languageChangeRedirect
      ] = await Promise.all([
        getLanguages(this.countryCode),
        getLanguageUrlLabels(),
        getLanguageLabels(),
        this.countryCode==='qa' || this.countryCode==='pk' || this.countryCode==='in'?isRedirectToHomeOnLangChange(this.countryCode):false
      ]);
      this.languages = languages;
      this.languageLabels = languageLabels;
      this.languageChangeRedirect = languageChangeRedirect;
      this.languageUrlLabels = languageUrlLabels; // stored for later use
    },
    async loadCountryData() {
      const country = await getCountryName(this.countryCode);
      this.country = country;
    },
    async loadResourceGroup() {
      try {
        const res = await getCountryResourceGroup(this.countryCode);
        const nonLiveCountryJson = res?.fields?.resJson?.['non-live-countries']?.find((item) => item?.country === this.countryCode);

        console.log("nonLiveCountryJson------------------", nonLiveCountryJson?.decommission);

        this.isDecommission = !!nonLiveCountryJson?.decommission;
      } catch (e) {
        console.error("Resource group error", e);
        this.isDecommission = false;
      }
    },
    async loadCountryLoginUrl() {
      try {
        const url = await getCountryLoginUrl(
          this.countryCode,
          this.languageCode
        );

        if (url) {
          console.log("usvisascheduling");
          this.scheduleurl = url;
        } else {
          console.log("cgifederal");
          this.acsflag = true;
        }

      } catch (error) {
        console.error(error);
        this.acsflag = true;
      }
    },
    async loadAcsLoginUrl() {
      try {
        const countryLoginUrl = await getCountryAcsLoginUrl(
          this.countryCode,
          this.languageCode
        );
        this.countryLoginUrl = countryLoginUrl;
        if (countryLoginUrl) {
          this.scheduleurl1 = countryLoginUrl;
        } else {
          document.getElementById("acs-login").className = document.getElementById("acs-login").className.replace( /cgi-schedule2/g , 'cgi-schedule' )
        }
      } catch (e) {
        console.error("ACS login error", e);
      }
    }
  },
  /*
  created() {
    console.log('Pooja - version -1 deployment check in staging');
    document.addEventListener("click", this.outsideMenuClickHandler);
    this.$root.$on("modal-popup:hide", () => {
      this.showModal = false;
      this.quickNotice = true;
    });
    if (location.search.includes('nodialog')) {
      this.showModal = false;
      this.quickNotice = false;
    }
    getDataByForTranslation("buttonCta", "schedule-appt", this.$route.params.countrycode, this.$route.params.langcode).then((pageData) => {
      console.log('here it is========', this.$route);
      this.dataLoaded = true;
      if (!pageData) {
        console.log('404');
      }
      this.pageData = pageData;
    });
    this.countryCode = urlCountryCode();
    let languageCode = urlLangCode();
    let origin = window.location.origin;

    // if(origin=='https://cgistaging.scriptbytes.co.in' && this.countryCode=='lv' && languageCode=='ru'){
    //  this.$router.push(`/${this.countryCode}/en/`)
    // }


    Promise.all([
      getLanguages(this.countryCode),
      getLanguageUrlLabels(),
      getLanguageLabels(),
      this.countryCode==='qa' || this.countryCode==='pk' || this.countryCode==='in'?isRedirectToHomeOnLangChange(this.countryCode):false,
    ]).then(([languages, languageUrlLabels, languageLabels, languageChangeRedirect]) => {
      this.languageChangeRedirect = languageChangeRedirect;
      this.languages = languages;
      this.languageLabels = languageLabels;
      getCountryName(this.countryCode).then((country) => {
        this.country = country;
        const fullLanguage = languageUrlLabels[urlLangCode()];
        //pooja, 10-july-2023, login url for country
        // getCountryLoginUrl(this.countryCode, this.$route.params.langcode).then((countryLoginUrl) => {
        //   this.countryLoginUrl = countryLoginUrl;
        //   if(countryLoginUrl) {this.scheduleurl = this.countryLoginUrl}
        //   else {
        //     this.acsflag = true;
        //     this.scheduleurl = 'https://cgifederal.secure.force.com/?language='+fullLanguage+'&country='+country;
        //   }
        // });

        getCountryResourceGroup(this.countryCode).then((res) => {
          console.log("tresponse -------------------------------------------------", res, this.countryCode);
          const nonLiveCountryJson = res?.fields?.resJson['non-live-countries']?.find((item) => item?.country === this.countryCode);
          console.log("nonLiveCountryJson------------------", nonLiveCountryJson?.decommission);
          if (nonLiveCountryJson?.decommission) {
            this.isDecommission = true;
          } else {
            this.isDecommission = false;
          }
        });

        function getCountryLoginPromise(countryCode, langCode) {
          return new Promise((resolve, reject) => {
            console.log("country code ...................", countryCode);
            getCountryLoginUrl(countryCode, langCode)
              .then((countryLoginUrl) => {
                console.log("============================");
                console.log(countryLoginUrl);
                console.log("============================");

                if (countryLoginUrl) {
                  console.log("usvisascheduling");
                  resolve(countryLoginUrl);
                } else {
                  console.log("cgifederal");
                  reject("No country login URL found.");
                }
              })
              .catch((error) => {
                reject(error);
              });
          });
        }

        getCountryLoginPromise(this.countryCode, this.$route.params.langcode)
        .then((url) => {
          this.scheduleurl = url;

        })
        .catch((error) => {
          console.error(error);
          this.acsflag = true;
        });


        getCountryAcsLoginUrl(this.countryCode, this.$route.params.langcode).then((countryLoginUrl) => {
          this.countryLoginUrl = countryLoginUrl;
          if(countryLoginUrl) {this.scheduleurl1 = this.countryLoginUrl}
          else{
            document.getElementById("acs-login").className = document.getElementById("acs-login").className.replace( /cgi-schedule2/g , 'cgi-schedule' )
          }
        });
      });
    });

  },
  */
  async created() {
    console.log('master version - 14-Jul-2026');
    document.addEventListener("click", this.outsideMenuClickHandler);
    this.$root.$on("modal-popup:hide", () => {
      this.showModal = false;
      this.quickNotice = true;
    });
    if (location.search.includes('nodialog')) {
      this.showModal = false;
      this.quickNotice = false;
    }
    try {
      this.countryCode = await urlCountryCode();
      this.languageCode = await urlLangCode();      
      await this.loadLanguageData();
      this.loadCountryData();
      this.loadResourceGroup();
      this.loadCountryLoginUrl();
      await this.$nextTick();
      this.loadAcsLoginUrl();
    } catch (error) {
      console.error("Created flow failed", error);
    }
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }

          console.warn(warn)
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        // add Event Listeners
        document.addEventListener('click', handler)
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null

      }
    }
  },
  beforeCreate() {
    getTranslationKeywords(urlLangCode()).then(
      (keywords) => (console.log(this.translationKeywords = keywords))
    );
  },
  mounted() {
    this.$root.$on("modal-popup:show", () => {
      this.showModal = true;
      this.quickNotice = false;
    });
    //  pooja, 16-jul-2025, 508- focus on notice button after modal close
    // pooja,zubair, 07-04-26, focus issue fix after modal close for notice button
    this.$root.$on("modal-popup:hide", () => {
      setTimeout(() => {
        document.getElementById('notice-btn').focus({ preventScroll: true })
      }, 300);
    });
  },
};
</script>

<style lang="scss" scoped>
//  pooja, 04-jun-2025, long text handling 
.over-flow {
  max-width: 125px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  // pooja 14-jan-26, header hindi text top bottom issue
  line-height: 22px;
}

.usa-megamenu {
  display: none;
}

.show-non {
  display: block;
}

.none {
  display: none;
}

.single-head {
  bottom: 2rem !important;
}

.index-page {
  .single-head {
    bottom: 1.5rem !important;
  }
}

.block {
  display: block;
}

.mobile-only {
  display: none;
}

#acs-login #visa-login {
  padding-left: 15px;
  padding-right: 19px;
}
::v-deep .green-button a {
  font-family: 'Open Sans', 'Source Sans Pro Web', Helvetica Neue, Helvetica, Roboto, Arial,sans-serif;
  font-size: 16px;
  line-height: 0.93923;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 0;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  margin-right: 0.5rem;
  padding: 1rem 1.5rem;
  text-align: center;
  text-decoration: none;
  width: auto;

  span {
    display: none;
  }

  &:hover {
    color: #FFF;

    span {
      display: none;
    }
  }
}

::v-deep .green-button a:before {
  content: url("/assets/img/calender.svg");
  left: 17px;
  position: absolute;
}

//pooja, 23-may-2025, country name handle for long text 
.country-tag {
  max-width: 118px;
  display: inline-block;
  text-align: center;
  vertical-align: text-bottom;
  margin-right: 5px;
}

#dialog-1 {
  display: none;
}

.DispalyNone {
  display: none;
}

.showModal {
  display: block !important;
}

.quick-notice {
  background: #FFF;
  padding: 10px 0;
  width: 192px;
  position: absolute;
  top: 0;
  z-index: 999;
  outline: .25rem solid #2491ff;
  text-align: center;

  .notice-btn {
    background: transparent;
    text-decoration: underline;
    margin: 0;
    border: 0;
    padding: 0;
    color: #004370;
    font-size: 1.1rem;

    &:focus,
    &:active {
      outline: none;
    }
  }
}

.permanentHide {
  display: none;
}

@media (min-width: 320px) and (max-width: 767px) {
  .usa-nav__primary {
    button {
      background: none;
    }
  }
  .mobile-only {
    display: block;
    float: right;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .usa-nav__primary {
    button {
      background: none;
    }
  }
  .mobile-only {
    display: block;
    float: right;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .usa-nav__primary {
    button {
      background: none;
    }
  }

  .mobile-only {
    display: block;
    float: right;
  }
}
// ZS, 6 Sep 23, header overlapping issue fixes
@media (min-width: 64em) {
  .usa-header--extended .usa-logo {
    font-size: 2rem;
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .usa-nav__primary>.usa-nav__primary-item {
    max-width: 174px;
  }
}

.usa-logo a.radius-pill {
  font-size: 13px;
  font-weight: 600;
}
.cgi-schedule {
   margin-right: 1.5rem;
 }
@media screen and (min-width: 1024px) {
  .rtl-global .cgi-schedule2 {
    left: 12.5rem;
    right: initial;
  }

  .cgi-schedule2 {
    right: 13rem;
    bottom: 0px;

  }
  .cgi-schedule-btns {
    position: absolute;
    display: flex;
    align-items: center;
    height: 50px;
    right: 0;
  }
}

.usa-nav__inner {
  display: flex;
  flex-direction: column;
}

.grid-row.usa-nav__secondary {
  order: 2;
  margin-top: 0;
}

.usa-nav__primary.usa-accordion {
  order: 0;
}

.order-btns {
  order: 3;
}
.department-logo {
   display: flex;
   align-items: center;
 }
 .usa-grouped-logo {
   display: flex;
   align-items: center;
   .flag-img {
     width: 75px;
   }
   .dos-img {
     width: 55px;
   }
   .ustd-text {
     width: 150px;
     transform: translate(2px, 5px);
   }
 }
 .rtl-global {
   .usa-grouped-logo {
     padding-right: 5px;
     .ustd-text {
       transform: translate(1px, 5px);
     }
   }
 }
 /* Only For Tablet and Mobile View */
 @media (max-width: 63.99em) {
   .usa-grouped-logo {
     .flag-img {
       width: 55px;
     }
     .dos-img {
       display: none;
     }
     .ustd-text {
       width: 135px;
       transform: translate(3px, 3px);
     }
   }
   .country-tag {
     max-width: 110px;
     margin-right: 2px;
     font-size: 0.75em !important;
     font-weight: 400 !important;
   }
 }
 /* Small Device which is less than 400 */
 @media (max-width: 25em) {
   .usa-grouped-logo {
     .flag-img {
       width: 45px;
     }
     .dos-img {
       display: none;
     }
     .ustd-text {
       width: 110px;
       transform: translate(1px, 2px);
     }
   }
   .country-tag {
     max-width: 100px;
     margin-right: 0;
     font-size: 0.7em !important;
     font-weight: 400 !important;
     object-fit: contain;
   }
   .usa-menu-btn.usa-menu-btn {
     svg {
       width: 25px;
     }
     font-size: 10px;
   }
   .usa-banner__header-text {
     font-size: 0.59853rem;
   }
 }
</style>